import type { ReactNode } from 'react';
import { Polygon } from 'react-leaflet';
import { type PathProps } from '@react-leaflet/core';
import 'leaflet/dist/leaflet.css'
import { type PolylineOptions } from 'leaflet';
import { computeDestinationPoint } from 'geolib';


export interface RegularPolygonProps extends  PolylineOptions, PathProps {
  center: { 
    lat: number, 
    lon: number 
  }; 
  size: number; 
  sides: number;
  children?: ReactNode;
}

export const RegularPolygon = ( props: RegularPolygonProps) => {
  const { center, size, sides } = props;
  const points = Array<[number, number]>();
  for (let i = 0; i < sides; i++) {
    const point = computeDestinationPoint(center, size, i * (360.0 / sides));
    points.push([point.latitude, point.longitude]);
  }
  return (
    <Polygon {...props} positions={points} />
  )
};